import { useSnackbar, ProviderContext, VariantType } from 'notistack'
import { useTranslation } from 'react-i18next'

let useSnackbarRef: ProviderContext
const setUseSnackbarRef = (useSnackbarRefProp: ProviderContext) => {
  useSnackbarRef = useSnackbarRefProp
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let useTranslationRef: any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setUseTranslationRef = (useTranslationRefProp: any) => {
  useTranslationRef = useTranslationRefProp
}

interface ISnackbarUtilsConfiguratorProps {
  setUseSnackbarRef: typeof setUseSnackbarRef
  setUseTranslationRef: typeof setUseTranslationRef
}

const InnerSnackbarUtilsConfigurator = (
  props: ISnackbarUtilsConfiguratorProps,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any => {
  props.setUseSnackbarRef(useSnackbar())
  props.setUseTranslationRef(useTranslation())
  return null
}

export const SnackbarUtilsConfigurator = () => {
  return (
    <InnerSnackbarUtilsConfigurator
      setUseSnackbarRef={setUseSnackbarRef}
      setUseTranslationRef={setUseTranslationRef}
    />
  )
}

export const snackActions = {
  success(msg: string) {
    this.showMessage(msg, 'success')
  },
  warning(msg: string) {
    this.showMessage(msg, 'warning')
  },
  info(msg: string) {
    this.showMessage(msg, 'info')
  },
  error(msg: string) {
    this.showMessage(msg, 'error')
  },
  showMessage(msg: string, variant = 'default') {
    useSnackbarRef.enqueueSnackbar(useTranslationRef.t(msg), {
      preventDuplicate: true,
      variant: variant as VariantType,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center',
      },
    })
  },
}
